// extracted by mini-css-extract-plugin
export var attribution = "_9v-4";
export var authorName = "_9v-5";
export var quote = "_9v-3";
export var testimonial = "_9v-2";
export var trustedBy = "_9v-0";
export var trustedByLabel = "_9v-1";